import { Col, Container, Row } from "react-bootstrap";
import bitsOfCode from "../../Assets/Projects/blog.png";
import chatify from "../../Assets/Projects/chatify.png";
import courier from "../../Assets/Projects/courier.bmp";
import garbage from "../../Assets/Projects/garbage.png";
import suicide from "../../Assets/Projects/istoreApp.png";
import leaf from "../../Assets/Projects/istoreWeb.png";
import meerajSrgl from "../../Assets/Projects/meeraj-srgl.png";
import emotion from "../../Assets/Projects/movingCar.png";
import packman from "../../Assets/Projects/packman.bmp";
import editor from "../../Assets/Projects/switch.png";
import { useTranslation } from "../../i18n";
import Particle from "../Particle";
import ProjectCard from "./ProjectCards";

const PROJECT_ITEMS = [
  {
    id: "istoreApp",
    imgPath: suicide,
    isBlog: false,
    ghLink: "https://github.com/LokeshKhandelwal/iStoreWebApp",
  },
  {
    id: "istoreWeb",
    imgPath: leaf,
    isBlog: false,
    ghLink: "https://github.com/LokeshKhandelwal/istore-Mern",
    demoLink: "https://drive.google.com/file/d/1ZsT9cq7dSYEm3h1pmxqnRpRwCChwJtmD/view",
  },
  {
    id: "meerajSrgl",
    imgPath: meerajSrgl,
    isBlog: false,
    demoLink: "https://www.meerajsrgl.com/",
    demoLabel: "Website",
  },
  {
    id: "wasteAI",
    imgPath: garbage,
    isBlog: false,
    ghLink: "https://github.com/LokeshKhandelwal/Smart-waste-management",
    demoLink: "https://smart-waste-management-6zuqtjm8awlrtjsg6bkcxw.streamlit.app/",
  },
  {
    id: "chitChat",
    imgPath: chatify,
    isBlog: false,
    ghLink: "https://github.com/LokeshKhandelwal/chitChat",
  },
  {
    id: "movingCar",
    imgPath: emotion,
    isBlog: false,
    demoLink: "https://lokeshkhandelwal.github.io/Moving-Car-WEB-DEVELOPMENT/",
    ghLink: "https://github.com/LokeshKhandelwal/Moving-Car-WEB-DEVELOPMENT",
  },
  {
    id: "blog",
    imgPath: bitsOfCode,
    isBlog: false,
    ghLink: "https://github.com/LokeshKhandelwal/blog",
    demoLink: "https://lokeshkhandelwal.github.io/blog/",
  },
  {
    id: "switch",
    imgPath: editor,
    isBlog: false,
    ghLink: "https://github.com/LokeshKhandelwal/Chrome-Extension-DarkMode",
  },
  {
    id: "courier",
    imgPath: courier,
    isBlog: false,
    // requestOnly: true,
  },
  {
    id: "pacman",
    imgPath: packman,
    isBlog: false,
    // requestOnly: true,
  },
];

function Projects() {
  const { t } = useTranslation();

  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          {t("projects.heading")}
        </h1>
        <p style={{ color: "white" }}>
          {t("projects.subheading")}
        </p>
        <p className="project-note">
          {t("projects.note")}
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          {PROJECT_ITEMS.map((project) => {
            const title = t(`projects.items.${project.id}.title`);
            const description = t(`projects.items.${project.id}.description`);
            const requestLabel = project.requestOnly ? t("projects.requestLabel") : undefined;
            return (
              <Col md={4} className="project-card" key={project.id}>
                <ProjectCard
                  imgPath={project.imgPath}
                  isBlog={project.isBlog}
                  title={title}
                  description={description}
                  ghLink={project.ghLink}
                  demoLink={project.demoLink}
                  demoLabel={project.demoLabel}
                  requestLabel={requestLabel}
                />
              </Col>
            );
          })}
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
